import { FilterUpIcon } from '../../../../../app/assets/icons/buttons';

export const ToggleOpenIcon = () => (
  <FilterUpIcon
    data-testid="filter-up-icon"
    className="rotate-90"
    height={20}
    width={10}
  />
);
